import { Component, OnInit, DoCheck } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginUserDto } from 'src/app/core/models/auth/login-user.dto';
import { TranslateDto } from 'src/app/core/models/translate/translate.dto';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { UserStorageService } from 'src/app/core/services/local/user-storage.service';
import { MyErrorStateMatcher } from 'src/app/core/shared/error/error-matcher';
import { ValidationHelper } from 'src/app/core/shared/helpers/validation.helper';
import { LockSessionService } from '../../core/services/auth/lock-session.service';
import { TranslatePipe } from 'src/app/core/pipes/translate.pipe';
import { Router } from '@angular/router';
import { StringUtilsHelper } from 'src/app/core/shared/helpers/strings.helper';
import { TranslateHelper } from 'src/app/core/shared/helpers/translate.helper';
import { SendInfoComponentService } from 'src/app/core/services/local/send-info.component.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { VersionLabelComponent } from 'src/app/core/shared/components/version-label/version-label.component';

@Component({
  selector: 'app-login-session-lock',
  templateUrl: './login-session-lock.component.html',
  styleUrls: ['./login-session-lock.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    AsyncPipe,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    TranslatePipe,
		VersionLabelComponent
  ],
})
export class LoginSessionLockComponent implements OnInit, DoCheck {
  user!: LoginUserDto;
  form!: FormGroup;
  matcher = new MyErrorStateMatcher();
  visibility: boolean = false;
  message: string = '';
  showMessage: boolean = false;

  listTraduction: TranslateDto = {} as TranslateDto;
  changeTraduction: boolean = false;
  labelFullName: string = '';

  expired$: Observable<boolean>;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private sendInfo: SendInfoComponentService,
    private userStorageService: UserStorageService,
    private lockSessionService: LockSessionService
  ) {
    let idle: string = userStorageService.getLock();
    this.changeStatusLock(JSON.parse(idle.toLowerCase()));
  }

  ngOnInit(): void {
    this.onListenTranslate();
    this.pnlMessage('', false);
    this.getFullName();
    this.form = this.fb.group({
      password: ValidationHelper.validateBasic(false),
    });
  }

  ngDoCheck(): void {
    if (this.changeTraduction) {
      this.changeTraduction = false;
    }
    this.getFullName();
  }

  onSubmit(): void {
    if (
      !StringUtilsHelper.notNullOrUndefinedOrEmpty(
        this.form.get('password').value
      )
    ) {
      this.pnlMessage(
        'No se permiten solo espacios como usuario y/o contraseña.',
        true
      );
      return;
    }
    if (this.form.valid) {
      this.user = this.form.value;
      this.user.username = this.userStorageService.getUsername();
      this.authService.login(this.user).subscribe({
        next: (resp) => {
          if (resp.authorized) {
            this.lockSessionService.detectInactivity().subscribe();
            this.userStorageService.setLock(false);
            this.changeStatusLock(false);
            this.pnlMessage('', false);
            this.lockSessionService.stopEndTimer();
            this.form.reset();
          } else {
            switch (resp.msg) {
              case 'msg_invalid':
                this.pnlMessage(
                  this.listTraduction.msg.get('msg_contrasenia_no_valida'),
                  true
                );
                break;
              case 'msg_esperar_10_min':
                this.pnlMessage(
                  this.listTraduction.msg.get('msg_esperar_min_contrasenia'),
                  true
                );
                break;
              default:
                this.pnlMessage(this.listTraduction.msg.get(resp.msg), true);
            }
          }
        },
      });
    }
  }

  changeStatusLock(idle: boolean) {
    this.lockSessionService.expired$ = new BehaviorSubject<boolean>(idle);
    this.expired$ = this.lockSessionService.expired$;
  }

  newSession() {
    this.userStorageService.logout();
    this.router.navigateByUrl('/');
    this.lockSessionService.finalizeLock();
  }

  pnlMessage(text: string, show: boolean) {
    this.showMessage = show;
    this.message = text;
  }

  getFullName() {
    if (
      StringUtilsHelper.notNullOrUndefinedOrEmpty(this.listTraduction.lbl) &&
      this.listTraduction.lbl.size > 0
    ) {
      this.labelFullName = this.listTraduction.lbl
        .get('lbl_hola_user')
        .replace('username', this.userStorageService.getFullName());
    }
  }

  onListenTranslate() {
    this.listTraduction = TranslateHelper.getTranslation('locksession', false);
    this.sendInfo.sendObjectAction.subscribe((data) => {
      if (data.isExecuted && data.key === 'traduction') {
        this.listTraduction = TranslateHelper.getTranslation(
          'locksession',
          false
        );
        this.changeTraduction = true;
      }
    });
  }
}
